import React from "react"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"
import Text from "../../common/components/Text"
import Thumb from "../images/Thumb"
import { OptionContainer, Option } from "./tagging/common"
import { CardSection } from "../../completion/components/Card"

const Container = styled(CardSection)`
  display: flex;
  padding: 16px 0 0;
  ${props =>
    props.selfCare
      ? css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `
      : ""};
`

const ThumbContainer = styled.div`
  display: inline-flex;
  align-self: center;
  margin-left: 32px;
`

const AgreeNumber = styled(Text)`
  padding-right: 5px;
`

const AgreeText = styled(Text)`
  width: 254px;
  max-width: 254px;
`

const ControlAgreement = ({ index, agreement, name, onSetAgreement }) => (
  <Container noBorder noShadow>
    <AgreeNumber>{`${index + 1}.`}</AgreeNumber>
    <AgreeText>{name}</AgreeText>
    <ThumbContainer>
      <Thumb
        selected={agreement === true}
        onClick={onSetAgreement.bind(null, true)}
      />
      <Thumb
        down
        selected={agreement === false}
        onClick={onSetAgreement.bind(null, false)}
      />
    </ThumbContainer>
  </Container>
)

const SelfCareFeedback = ({ feedback, name, onSetFeedback }) => (
  <Container selfCare noBorder noShadow>
    <AgreeText>{name}</AgreeText>
    <ThumbContainer>
      <Thumb selected={feedback} onClick={onSetFeedback.bind(null, true)} />
      <Thumb
        down
        selected={feedback === false}
        onClick={onSetFeedback.bind(null, false)}
      />
    </ThumbContainer>
  </Container>
)

const TestAgreement = ({ index, agreement, name, onSetAgreement }) => (
  <Container noBorder noShadow>
    <Text>
      {index + 1}. {name}
    </Text>
    <OptionContainer>
      <Option
        text="Yes"
        selected={agreement === true}
        onClick={onSetAgreement.bind(null, true)}
      />
      <Option
        text="No"
        selected={agreement === false}
        onClick={onSetAgreement.bind(null, false)}
      />
    </OptionContainer>
  </Container>
)

const DiagnosisAgreement = props => {
  if (props.selfCare) {
    return <SelfCareFeedback {...props} />
  }
  if (window.variant === "E") {
    return <TestAgreement {...props} />
  }
  return <ControlAgreement {...props} />
}

SelfCareFeedback.propTypes = {
  feedback: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onSetFeedback: PropTypes.func.isRequired,
}

const Props = {
  index: PropTypes.number,
  agreement: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onSetAgreement: PropTypes.func.isRequired,
}

TestAgreement.propTypes = Props

ControlAgreement.propTypes = Props

export { DiagnosisAgreement as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/DiagnosisAgreement.js